import gql from 'graphql-tag'
export default gql`mutation createSieveSizeMutation($sieveSize: BaseSieveSize!) {
  createSieveSize(sieveSize: $sieveSize) {
    code
    size
    id
  }
}`